import { POPUP_STYLE, ARROW_STYLE, MARKER_ANCHOR } from '../utils/markerConstants';
import { createPlanPopup } from '../utils/popupBuilder';
import { setOrders, setSolutionJson } from '../../../../actions';

export function attachHoverEvents(marker, ui, translations, map, ordersRef) {
  let popupElement = null;

  const removePopup = () => {
    if (popupElement) {
      if (popupElement._cleanup) {
        popupElement._cleanup();
      }
      popupElement.remove();
      popupElement = null;
    }
  };

  marker.addEventListener('pointerenter', () => {
    if (!popupElement) {
      const markerData = marker.getData();
      const markerPosition = marker.getGeometry();

      popupElement = document.createElement('div');
      Object.assign(popupElement.style, POPUP_STYLE);

      const content = createPlanPopup(markerData, translations, ordersRef.current);
      const arrow = document.createElement('div');
      Object.assign(arrow.style, ARROW_STYLE);

      popupElement.innerHTML = content;
      popupElement.appendChild(arrow);

      const mapContainer = map.getElement();
      mapContainer.appendChild(popupElement);

      const updatePopupPosition = () => {
        const anchorY = markerData.isEditing ? MARKER_ANCHOR.EDITING.y : MARKER_ANCHOR.NORMAL.y;
        const screenPos = map.geoToScreen(markerPosition);
        popupElement.style.left = `${screenPos.x}px`;
        popupElement.style.top = `${screenPos.y - anchorY - 4}px`;
      };

      updatePopupPosition();

      const updateListener = () => updatePopupPosition();
      map.addEventListener('mapviewchange', updateListener);

      popupElement._cleanup = () => {
        map.removeEventListener('mapviewchange', updateListener);
      };
    }
  });

  marker.addEventListener('pointerleave', removePopup);

  marker._removePopup = removePopup;
}

export function attachInteractionEvents(
  marker,
  feature,
  dispatch,
  ordersRef,
  solution,
  onMarkerDragEnd,
  map,
) {
  marker.addEventListener('contextmenu', (evt) => {
    evt.stopPropagation();
    const featureId = feature.properties.id;
    const newOrders = ordersRef.current.filter((o) => o.InternalID !== featureId);
    dispatch(setOrders(newOrders, false, solution.show));
    dispatch(setSolutionJson({ jsonTriggerVRP: true }));
  });

  marker.draggable = true;

  marker.addEventListener('dragstart', (evt) => {
    if (marker._removePopup) {
      marker._removePopup();
    }

    if (map._behavior) {
      map._behavior.disable();
    }

    const markerScreenPos = map.geoToScreen(evt.target.getGeometry());
    evt.target.offset = {
      x: evt.currentPointer.viewportX - markerScreenPos.x,
      y: evt.currentPointer.viewportY - markerScreenPos.y,
    };
    evt.stopPropagation();
  });

  marker.addEventListener('dragend', (evt) => {
    if (map._behavior) {
      map._behavior.enable();
    }
    evt.stopPropagation();
    onMarkerDragEnd(marker, feature);
  });

  marker.addEventListener('tap', (evt) => {
    evt.stopPropagation();
  });
}
